module.exports = __webpack_public_path__ + "img/hx-zlgl-w.d7923d58.svg";